import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NoteIcGlyph = /*#__PURE__*/createElement("g", {
  id: "note_ic"
}, /*#__PURE__*/createElement("path", {
  d: "M42 17.33c13.6 0 24.67 11.07 24.67 24.67S55.6 66.67 42 66.67 17.33 55.6 17.33 42 28.4 17.33 42 17.33m0-3c-15.28 0-27.67 12.39-27.67 27.67S26.72 69.67 42 69.67 69.67 57.28 69.67 42 57.28 14.33 42 14.33z"
}), /*#__PURE__*/createElement("path", {
  d: "M42 45.54a2.5 2.5 0 0 1-2.5-2.5V28.17a2.5 2.5 0 0 1 5 0v14.88c0 1.37-1.12 2.49-2.5 2.49z"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "54.06",
  r: "2.78"
}));
const NoteIc = createSvg({
  name: 'note_ic',
  path: NoteIcGlyph
});

export default NoteIc;
export { NoteIcGlyph };
